import {
    getActiveModule,
    internationalizeNumericValue,
    parseInternationalizedValue,
} from "@/ts/utils";
import { Input, Select } from "antd";
import React, { Dispatch, SetStateAction } from "react";
import $ from "jquery";
import { useSelector } from "react-redux";
import { IChannel } from "@/ts/common-types";
import { WinningBidRangeRenderer } from "../cell-renderers/AllCellRenderers";

interface IBidInputComponent {
    identifier: number;
    inputValue: number | string;
    previousValue: number | string;
    isUIDisabled: boolean;
    setBidValue: Dispatch<SetStateAction<string | number>>;
    bidType: string;
    bidLimitMessage: string;
    setBidLimitMessage: Dispatch<SetStateAction<string>>;
    params: any;
    isSmartMatch?: boolean;
    setIsSubmitBtnDisabled?: Dispatch<SetStateAction<boolean>>;
    keywordBidSlots: Array<number>;
    setKeywordBidSlots: Dispatch<SetStateAction<Array<number>>>;
    maxBidLimitRecordTypes: Array<string>,
    canBidInputBeDisabled: boolean,
    isSlotChangeRequired: boolean,
}

const BidInputComponent: React.FC<IBidInputComponent> = ({
    identifier,
    inputValue,
    previousValue,
    isUIDisabled,
    setBidValue,
    bidType,
    bidLimitMessage,
    setBidLimitMessage,
    params,
    isSmartMatch,
    setIsSubmitBtnDisabled,
    keywordBidSlots,
    setKeywordBidSlots,
    maxBidLimitRecordTypes,
    canBidInputBeDisabled,
    isSlotChangeRequired,
}) => {
    const { activeModule } = getActiveModule();
    const currencySymbol = useSelector(
        (state: IChannel) => state.channelCurrencySymbol.value
    );

    const handleBidBudgetChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        type: string
    ) => {
        const changedBid = e.target.value;
        if (changedBid < params.data.min_bid_value) {
            setBidLimitMessage(
                `Enter a value above ${currencySymbol}${params.data.min_bid_value}`
            );
            $(`#${identifier}${type ? `-${type}` : ""}-bid-limit-span`).show();
            setIsSubmitBtnDisabled(true);
        } else if (
            maxBidLimitRecordTypes.includes(params.data.record_type) &&
            changedBid > params.data.max_bid_value
        ) {
            setBidLimitMessage(
                `Enter a value less than  ${currencySymbol}${params.data.max_bid_value}`
            );
            $(`#${identifier}${type ? `-${type}` : ""}-bid-limit-span`).show();
            setIsSubmitBtnDisabled(true);
        } else {
            setBidLimitMessage("");
            $(`#${identifier}-${type ? `-${type}` : ""}-bid-limit-span`).hide();
        }
    };

    return (
        <div>
            <label
                className="fw-bold mb-1"
                htmlFor={
                    bidType
                        ? `${identifier}-${bidType}-update-field`
                        : `${identifier}-bid-update-field`
                }
            >
                {bidType ? `${bidType} Match CPM Bid` : "Bid"}
            </label>
            <div className="d-flex justify-content-between">
                <Input
                    type="text"
                    name="bid-input"
                    defaultValue={inputValue}
                    value={inputValue}
                    data-value={parseInternationalizedValue(inputValue)}
                    id={`${identifier}-${bidType? bidType : "bid"}-update-field`}
                    className="border border-pill"
                    data-id={identifier}
                    disabled={
                        canBidInputBeDisabled &&
                        (bidType === "Exact" ? isUIDisabled : !isSmartMatch)
                    }
                    onFocus={() =>
                        setBidValue(
                            parseInternationalizedValue(
                                inputValue ? inputValue : previousValue
                            )
                        )
                    }
                    onBlur={() =>
                        setBidValue(
                            internationalizeNumericValue(
                                inputValue ? inputValue : previousValue
                            )
                        )
                    }
                    onChange={(e) => {
                        if (
                            [
                                "keywords",
                                "product-analytics",
                                "keyword-analytics",
                            ].includes(activeModule) ||
                            /^\d*\.?\d{0,2}$/.test(e.target.value)
                        ) {
                            setBidValue(e.target.value ? e.target.value : "");

                            handleBidBudgetChange(e, bidType);
                        }
                    }}
                    style={{
                        width: "5rem",
                        fontSize: "12px",
                        padding: "2px 3px",
                        marginRight: "5px",
                    }}
                />
            </div>
            {isSlotChangeRequired && (
                <>
                    <label
                        className="fw-bold mt-2 mb-1 d-block"
                        htmlFor={`${identifier}-bid-slot-update-field`}
                    >
                        Slot
                    </label>
                    <Select
                        placeholder="Select slot"
                        defaultValue={keywordBidSlots}
                        size="small"
                        mode="multiple"
                        style={{
                            minWidth: "6rem",
                            fontSize: "12px",
                            padding: "2px 3px",
                            marginRight: "5px",
                        }}
                        onChange={(value) => setKeywordBidSlots(value)}
                    >
                        <Select.Option value={1}>Slot 1</Select.Option>
                        <Select.Option value={2}>Slot 2</Select.Option>
                        <Select.Option value={3}>Slot 3</Select.Option>
                    </Select>
                </>
            )}

            <WinningBidRangeRenderer
                {...{
                    params,
                    bidType,
                    identifier,
                }}
            />
            <div
                className="mt-2 align-items-center text-danger"
                style={{
                    lineHeight: "1.5",
                    fontSize: "10px",
                    display: "none",
                }}
                id={`${identifier}${bidType? `-${bidType}` : ""}-bid-limit-span`}
            >
                <span className="me-1">{bidLimitMessage}</span>
            </div>
        </div>
    );
};

export default BidInputComponent;
